<template src="./graficaAuxiliar.html">
    
</template>
<script>
export default {
    methods: {
        verTabla(){
            console.log('holaaaa aqui va ir la tabla')
            this.$router.push({name: 'tablaRhb'})
        }
    },
}
</script>
<style src="./graficaAuxiliar.scss" lang="sass" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Gestion/gestionRehabilitacion/graficaAuxiliar/graficaAuxiliar.vue